import { handleLinkByTypeV2 } from "@/helpers/common/handleLinkByType";
import OfferTimeCountDown from "./OfferTimeCountDown";
import { countDownHandler } from "@/utils/global";
import Image from "@/components/global/Image";
import { useRouter } from "next/router";
// import { copyToClipboard } from "@/components/global/ClipBoard";

const OfferEndDate = ({ headerJson = [] }) => {
  const activeData = headerJson?.find(
    (item) => item?.active && item?.key === "categories"
  );
  const category = activeData?.value?.[0];
  
  console.log('headerJson', category)
  const { locale, push} = useRouter();

  return (
    <>
      {activeData?.active &&
        countDownHandler(category?.["date-to"]).isCountDown && (
          <div
            onClick={() => category?.url ? push(handleLinkByTypeV2(category?.url, category?.type)) : null}
            className="flex items-center gap-3 px-3 max-sm:pt-2 max-sm:justify-center"
          >
            {/* <HeaderDiscountIcon className="max-sm:size-5" /> */}
            <Image
              src={category?.img || "/imgs/offers-1.gif"}
              className="object-contain w-7 sm:w-10 animate-bounce"
              alt=""
            />
            <div className="flex gap-1 text-xs font-bold text-center text-red-600 md:mb-2 md:max-w-32 max-sm:mb-2 md:text-start max-lg:flex-wrap w-fit sm:flex-col animate-pulse">
              <span>{category?.[`title-${locale}`]}</span>
              {activeData?.value?.[0]?.["show-time"] ? (
                <OfferTimeCountDown counter={category} />
              ) : null}
            </div>
          </div>
        )}
    </>
  );
};

export default OfferEndDate;
